import { Skeleton } from "@aircall/ds";

import { SkeletonTagProps } from "./SkeletonTag.decl";

export function SkeletonTag({ h = 18, w = 60 }: SkeletonTagProps) {
  return <Skeleton className="rounded-md" style={{ height: h, width: w }} />;
}
